$(document).ready(function () {
  // Shipping Delivery calculation
  var calculator = {
    workDaysAdded: 0,
    month: [ "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec" ],
    monthFull: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    weekday: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    weekdayFull: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    ukHolidays: ["2025-11-27","2025-12-25","2026-01-01"],  //"2023-05-23", "2023-05-24" "2025-12-25","2026-01-01"
    startDate: null,
    curDate: null,
    addWorkDay: function () {
      this.curDate.setDate(this.curDate.getDate() + 1);
      if (
        this.ukHolidays.indexOf(this.formatDate(this.curDate)) === -1 &&
        this.curDate.getDay() !== 0 &&
        this.curDate.getDay() !== 6
      ) {
        this.workDaysAdded++;
      }
    },
    formatDate: function (date) {
      var day = date.getDate(), month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;
      return date.getFullYear() + "-" + month + "-" + day;
    },
    getNewWorkDay: function (daysToAdd) {
      this.startDate = new Date();
      this.curDate = new Date(this.startDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      this.workDaysAdded = 0;

      while (this.workDaysAdded < daysToAdd) {
        this.addWorkDay();
      }
      return [
        this.weekday[this.curDate.getDay()],
        this.month[this.curDate.getMonth()],
        this.curDate.getDate(),
        this.weekdayFull[this.curDate.getDay()],
        this.monthFull[this.curDate.getMonth()],
      ];
    }, 
  };
  // Ajax drawer js start
  var ajaxCartDrawer = {
    AjaxcartUpdateCartCount: function (cart) {
      var CartCount = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("count");
      $("[data-cart-count]").html(CartCount);
      var price_without_money = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("cart-total-price");
      var price_with_money = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("cart-total-money");
      $("#product-content").html(price_without_money);
      $(".cart-subtotal__price").html(price_with_money);
    },
    AjaxcartNoProduct: function (elements) {
      $("[data-cart-wrapper],#shopify-section-cart-faqs").addClass("hide");
      $("[data-empty-page-content]").removeClass("hide");
      $("body").removeClass("show-cart-loader");
    },
    AjaxUpdateProtectionButtonPrice: function (item, handle_type) {
      try {
        var variant_price = parseInt(item.data("variant-compare-price-without-currency")) > parseInt(item.data("variant-price-without-currency")) ? parseInt(item.data("variant-compare-price-without-currency")) : parseInt(item.data("variant-price-without-currency"));
        var hasProtectionBuyButton = item.find(".add-protection-product");
        if (!hasProtectionBuyButton.length) {
          return false;
        }
        var product_type = item.data("cart-item-type"),
          protection_variant_list,
          is_bridal_product = false;
        if (
          product_type.indexOf("engagement-ring") > -1 ||
          product_type.indexOf("preset") > -1 ||
          product_type.indexOf("final-ring") > -1 ||
          product_type.indexOf("anniversary-bands") > -1 ||
          product_type.indexOf("bands-with-diamonds") > -1 ||
          product_type.indexOf("metal-bands") > -1 ||
          product_type.indexOf("eternity-bands") > -1
        ) {
          is_bridal_product = true;
        }
        if (is_bridal_product) {
          protection_variant_list = theme.protection_product_lifetime;
          $("#popup-protection-option-1").val("3 Year");
          $("#popup-protection-option-2").val("5 Year");
          $("#popup-protection-option-3").val("Lifetime");
          $(".protection-option-1 .update-year").text("3 Year");
          $(".protection-option-2 .update-year").text("5 Year");
          $(".protection-option-3 .update-year").text("Lifetime");
          $(".protection-option-3 sup").css("display", "inline");
        } else {
          protection_variant_list = theme.protection_product_3y;
          // Code to change input value in cart page protection popup
          $("#popup-protection-option-1").val("1 Year");
          $("#popup-protection-option-2").val("2 Year");
          $("#popup-protection-option-3").val("3 Year");
          $(".protection-option-1 .update-year").text("1 Year");
          $(".protection-option-2 .update-year").text("2 Year");
          $(".protection-option-3 .update-year").text("3 Year");
          $(".protection-option-3 sup").hide();
        }
        var price_range = "";
        for (var obj in protection_variant_list) {
          var lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
          var higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
          if (
            variant_price >= lower_price_range &&
            variant_price <= higher_price_range
          ) {
            price_range = obj.split(" / ")[1];
            break;
          }
        }
        console.log(variant_price, price_range);
        if (is_bridal_product) {
          if (handle_type.indexOf("handle_onload") > -1) {
            return protection_variant_list[`3 / ${price_range}`][0];
          } else {
            return [
              ...protection_variant_list[`3 / ${price_range}`],
              ...protection_variant_list[`5 / ${price_range}`],
              ...protection_variant_list[`Lifetime / ${price_range}`],
            ];
          }
        } else {
          if (handle_type.indexOf("handle_onload") > -1) {
            return protection_variant_list[`1 / ${price_range}`][0];
          } else {
            return [
              ...protection_variant_list[`1 / ${price_range}`],
              ...protection_variant_list[`2 / ${price_range}`],
              ...protection_variant_list[`3 / ${price_range}`],
            ];
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    AjaxShowHideProtectionButton: function () {
      function showAllCartItem(item) {
        if (item == "Yes") {
          $(".cart__products").addClass("show-all-items");
          $("#show-hidden-item").prop("checked", true);
        } else {
          $(".cart__products").removeClass("show-all-items");
        }
      }
      showAllCartItem(theme.get_local_storage("show-all-cart-item"));
      $("#show-hidden-item").on("change", function () {
        var isChecked = $(this).prop("checked");
        if (isChecked) {
          showAllCartItem("Yes");
          theme.set_local_storage("show-all-cart-item", "Yes");
        } else {
          showAllCartItem("No");
          theme.set_local_storage("show-all-cart-item", "No");
        }
      });
      var timestampObj = {};
      $("#withclarity-ajax-cart [data-cart-item-type]").each(function () {
        var buttonPrice = ajaxCartDrawer.AjaxUpdateProtectionButtonPrice(
          $(this),
          "handle_onload"
        );
        $(this)
          .find(".item-protection-button span")
          .text(theme.Currency.formatMoney(buttonPrice, theme.moneyFormat));
        var timestamp = $(this).find(".property__timestamp").data("value");
        // console.log(timestamp);
        if (timestamp in timestampObj) {
          timestampObj[timestamp] += 1;
        } else if (timestamp) {
          timestampObj[timestamp] = 1;
        }
      });
      console.log(timestampObj);
      function loadRemoveProtectionHtml(timestamp) {
        var protectionProduct = $(
          `.cart__row.protection[data-cart-timestamp="${timestamp}"]`
        );
        var protectionProductTitle = protectionProduct
          .find(".property__product-name")
          .data("value");
        var protectionProductPrice = protectionProduct.data("variant-total-price");
        var protectionProductYear = protectionProduct.find(".variant-option__year").data("value") + "";
        if (protectionProductYear.indexOf("Lifetime") < 0) {
          protectionProductYear += " Year";
        }
        if (protectionProductYear.indexOf("Lifetime") > -1) {
          protectionProductYear += "<sup>*</sup>";
        }
        var protectionProductCartKey = protectionProduct.data("cart-item-key");
        var protectionRemoveHtml = `<li class="protection-remove-wrapper">
        <p class="protection-remove-title">Clarity Commitment Protection Plan</p>
        <p class="protection-remove-text test">${protectionProductYear} Extended Warranty on ${protectionProductTitle}</p>
        <p class="protection-remove-price">${protectionProductPrice}</p>
        <p class="protection-remove-button" data-cart-item-key="${protectionProductCartKey}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" class="layer"></path></svg></p>
        </li>`;
        return protectionRemoveHtml;
      }
      for (let timestamp in timestampObj) {
        var productCount = timestampObj[timestamp];
        if (productCount == 3 && timestamp.indexOf("engagement-ring") > -1) {
          $(`.cart__row [data-value="${timestamp}"]`)
            .closest(".cart__row")
            .find(".protection-action__add")
            .remove();
          $(`.cart__row[data-cart-timestamp="${timestamp}"]`)
            .find(".protection-action__added")
            .append(loadRemoveProtectionHtml(timestamp))
            .addClass("mb--30");
        } else if (
          productCount == 2 &&
          timestamp.indexOf("engagement-ring") < 0
        ) {
          $(`.cart__row [data-value="${timestamp}"]`)
            .closest(".cart__row")
            .find(".protection-action__add")
            .remove();
          $(`.cart__row[data-cart-timestamp="${timestamp}"]`)
            .find(".protection-action__added")
            .append(loadRemoveProtectionHtml(timestamp))
            .addClass("mb--30");
        }
      }
    },
    AjaxcartRender: function () {
      $("body").addClass("show-cart-loader");
      $.ajax({
        url: "/cart?view=ajax",
        type: "get",
        async: false,
        success: function (cart) {
          $("#withclarity-ajax-cart").html(cart);
          ajaxCartDrawer.AjaxcartUpdateCartCount();
          $("body").removeClass("show-cart-loader");
          ajaxCartDrawer.AjaxShowHideProtectionButton();
          $("#withclarity-ajax-cart [data-cart-item-type]").each(function () {
            const custom_delivery_date_selector = $(this).find(".custom-delivery-date_property");
            const day = custom_delivery_date_selector.attr("data-ships-in");
            const variant_quantity = parseInt(custom_delivery_date_selector.attr("data-variant-quantity"));
            if(variant_quantity > 0){
              var newWorkDay = calculator.getNewWorkDay(day);
            }else{
              var newWorkDay = calculator.getNewWorkDay(9);
            }
            custom_delivery_date_selector.find("[data-cart-item-property-value]").text(`${newWorkDay[0]}, ${newWorkDay[1]} ${newWorkDay[2]}`);
          });
        },
        error: function (e) {
          $("body").removeClass("show-cart-loader");
          ajaxCartDrawer.AjaxcartUpdateCartCount();
          alert(e.responseJSON.message);
        },
      });
    },
    AjaxcartUpdateHnadler: function (updates) {
      $("body").addClass("show-cart-loader");
      $.ajax({
        url: "/cart/update.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: { updates },
        async: true,
        success: function (cart) {
          console.log(cart);
          ajaxCartDrawer.AjaxcartRender();
          var CartCount = cart.item_count;
          $("[data-cart-count]").html(CartCount);
          $(".cart-popup__heading span").text(CartCount);
          if (!CartCount) {
            ajaxCartDrawer.AjaxcartNoProduct();
          }
          // window.location.href = "/cart";
        },
        error: function (e) {
          $("body").removeClass("show-cart-loader");
          // ajaxCartDrawer.AjaxcartUpdateCartCount();
          alert(e.responseJSON.message);
          window.location.href = "/cart";
        },
      });
    },
    updateProtectionPlanInventory: function (data,product_timestamp,total_timestamp_length) {
      var {quantity} = data,protection_item_line;
      var all_relative_timestamp = $(`[data-cart-timestamp="${product_timestamp}"]`);
      all_relative_timestamp.each(function () {
        var item_type = $(this).data("cart-item-type");
        console.log("item_type",item_type,item_type.includes("protection"));
        if(item_type.includes("protection")){
          protection_item_line = $(this).data("cart-item-index");
        }
      });
      console.log(protection_item_line,total_timestamp_length,product_timestamp);
      if(protection_item_line){
        var data = {
          line: protection_item_line,
          quantity: quantity,
        }
        ajaxCartDrawer.AjaxcartChangeHandler(data,total_timestamp_length,false);
      }
    },
    AjaxcartChangeHandler: function (data,product_timestamp,total_timestamp_length,check_protection_product) {
      $("body").addClass("show-cart-loader");
      $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: data,
        async: true,
        success: function (cart) {
          if(total_timestamp_length > 1 && check_protection_product){
            ajaxCartDrawer.updateProtectionPlanInventory(data,product_timestamp,total_timestamp_length);
          }else{
            ajaxCartDrawer.AjaxcartRender();
            var CartCount = cart.item_count;
            $("[data-cart-count]").html(CartCount);
            $(".cart-popup__heading span").text(CartCount);
            if (!CartCount) {
              ajaxCartDrawer.AjaxcartNoProduct();
            }
          }
          // window.location.href = "/cart";
        },
        error: function (e) {
          $("body").removeClass("show-cart-loader");
          // ajaxCartDrawer.AjaxcartUpdateCartCount();
          alert(e.responseJSON.message);
          window.location.href = "/cart";
        },
      });
    },
    AjaxcartQuantityHandler: function () {
      $(document).on("click", ".qty_plus", function () {
        var product_title = $(this).closest(".cart__row").data("cart-item-title");
        var max_quantity = parseInt($(".cart__products").data("appraisal-limit"));
        var product_timestamp = $(this).closest(".cart__row").data("cart-timestamp");
        var total_timestamp_length = $(`[data-cart-timestamp="${product_timestamp}"]`).length;
        var q = $(this).parent().find(".cart__qty-input").val(),i = 1,p = parseInt(i),u = parseInt(q) + p;
        if (product_title.indexOf("Appraisal Report") > -1 && u > max_quantity) {
          alert(`One appraisal report per product. Exception: Loose diamonds have no appraisal reports. Contact support for assistance.`);
          return false;
        }
        var line = $(this).closest(".cart__qty").find("input").attr("data-line"),
          params = {
            quantity: u,
            line: line,
          };
        $(this).parent().find(".cart__qty-input").val(u);
        ajaxCartDrawer.AjaxcartChangeHandler(params,product_timestamp,total_timestamp_length,true);
      });
      $(document).on("click", ".qty_minus", function () {
        var product_timestamp = $(this).closest(".cart__row").data("cart-timestamp");
        var total_timestamp_length = $(`[data-cart-timestamp="${product_timestamp}"]`).length;
        var q = $(this).parent().find(".cart__qty-input").val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
        if (i == q) {
          return false;
        }
        var line = $(this)
            .closest(".cart__qty")
            .find("input")
            .attr("data-line"),
          params = {
            quantity: u,
            line: line,
          };
        $(this).parent().find(".cart__qty-input").val(u);
        ajaxCartDrawer.AjaxcartChangeHandler(params,product_timestamp,total_timestamp_length,true);
      });
      $(document).on("change", ".cart__qty-input", function () {
        var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr("data-line")),
          product_timestamp = $(this).closest(".cart__row").data("cart-timestamp"),
          total_timestamp_length = $(`[data-cart-timestamp="${product_timestamp}"]`).length,
          params = {
            quantity: UpdatedQuantity,
            line: QuantityLine,
          };
        ajaxCartDrawer.AjaxcartChangeHandler(params,product_timestamp,total_timestamp_length,true);
      });
      $(document).on("click", ".protection-remove-button", function (e) {
        var warranty_item_key = $(this).attr("data-cart-item-key");
        var params = {};
        params[warranty_item_key] = 0;
        console.log(params);
        ajaxCartDrawer.AjaxcartUpdateHnadler(params);
      });
      $(document).on("click", ".cart-remove-btn", function (e) {
        e.preventDefault();
        try {
          var params = {};
          var is_protection_product = $(this)
            .closest(".cart__row")
            .hasClass("protection");
          if (is_protection_product) {
            var protection_item_key = $(this)
              .closest(".cart__row")
              .attr("data-cart-item-key");
            params[protection_item_key] = 0;
            ajaxCartDrawer.AjaxcartUpdateHnadler(params);
            return false;
          }
          var parant_div = $(this).closest(".cart__row");
          var item_timestamp_value = parant_div.attr("data-cart-timestamp");
          if (item_timestamp_value.length == 0) {
            params[
              $(this).closest(".cart__row").attr("data-cart-item-key")
            ] = 0;
          } else {
            $(`.cart__row[data-cart-timestamp='${item_timestamp_value}']`).each(
              function () {
                params[$(this).attr("data-cart-item-key")] = 0;
              }
            );
          }
          console.log(params);
          ajaxCartDrawer.AjaxcartUpdateHnadler(params);
        } catch (e) {
          console.log(e);
        }
      });
    },
    AjaxcartAddAppraisal: function () {
      $(document).on("click", ".cart__add-appraisal .btn", function (e) {
        e.preventDefault();
        var variant_id = $(this).data("product-id");
        var product_type = $(this).data("product-type");
        var appraisalProduct = {
          quantity: 1,
          properties: {},
        };
        appraisalProduct["id"] = variant_id;
        if (product_type.indexOf("add-appraisal") > -1) {
          appraisalProduct["properties"]["Note"] =
            "Including an appraisal report will extend shipping by 2 days.";
        }
        $("body").addClass("show-cart-loader");
        $("html, body").animate({ scrollTop: "0" });
        try {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: appraisalProduct,
            dataType: "json",
            async: true,
            success: function () {
              // window.location.href = "/cart";
              ajaxCartDrawer.AjaxcartRender();
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              console.log(XMLHttpRequest, textStatus, errorThrown);
            },
          });
        } catch (e) {
          console.loe(e);
        }
      });
      $(document).on(
        "click",
        ".free-gift-wrapper .primary-button",
        function (e) {
          e.preventDefault();
          var varaintId = $(this).data("variant-id");
          var appraisalProduct = {
            quantity: 1,
          };
          appraisalProduct["id"] = varaintId;
          $("body").addClass("show-cart-loader");
          try {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: appraisalProduct,
              dataType: "json",
              async: true,
              success: function () {
                // code to apply discount code to checkout
                if (varaintId == "45519923708187") {
                  $("#checkout-discount").val("FREESTUDS1000");
                } else if (varaintId == "45519923904795") {
                  $("#checkout-discount").val("FREESTUDS5000");
                } else if (varaintId == "45519924003099") {
                  $("#checkout-discount").val("FREESTUDS10000");
                }
                ajaxCartDrawer.AjaxcartRender();
              },
              error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.log(XMLHttpRequest, textStatus, errorThrown);
              },
            });
          } catch (e) {
            console.loe(e);
          }
        }
      );
      // appraisal popup button
      $(document).on(
        "click",
        ".cart__add-appraisal .appraisal-title",
        function () {
          $("body").addClass("show-website-popup");
          var product_type = $(this)
            .closest(".cart__add-appraisal")
            .find(".btn")
            .data("product-type");
          console.log(product_type);
          if (product_type.indexOf("add-appraisal") > -1) {
            $(".popup-overlay-content [data-id='appraisal']").show();
            $(".popup-overlay-content [data-id='jewelry-cleaner']").hide();
          } else {
            $(".popup-overlay-content [data-id='jewelry-cleaner']").show();
            $(".popup-overlay-content [data-id='appraisal']").hide();
          }
          $("#cart-appraisal-popup").addClass("show-popup-content");
        }
      );
      // clear diamond availability cookies
      $(".cart__submit-controls [type='submit']").on("click", function () {
        sessionStorage.removeItem("unavailable_diamond");
        sessionStorage.removeItem("diamond-checklist");
      });
    },
    handleBuyProtection: function () {
      var item_parent;
      $(document).on(
        "click",
        ".add-protection-product .item-protection-button",
        function () {
          $("body").addClass("show-website-popup");
          $("#clarity-commitment-popup").addClass("show-popup-content");
          item_parent = $(this).closest(".cart__row");
          var [
            price_option1,
            variant_option1,
            price_option2,
            variant_option2,
            price_option3,
            variant_option3,
          ] = ajaxCartDrawer.AjaxUpdateProtectionButtonPrice(
            item_parent,
            "handle_click"
          );
          $(".protection-option-1")
            .attr("data-protection-id", variant_option1)
            .find("p .update-price")
            .text(theme.Currency.formatMoney(price_option1, theme.moneyFormat));
          $(".protection-option-2")
            .attr("data-protection-id", variant_option2)
            .find("p .update-price")
            .text(theme.Currency.formatMoney(price_option2, theme.moneyFormat));
          $(".protection-option-3")
            .attr("data-protection-id", variant_option3)
            .find("p .update-price")
            .text(theme.Currency.formatMoney(price_option3, theme.moneyFormat));
          $(".protection-plan-wrapper .grid__item")
            .attr("data-timestamp", item_parent.data("cart-timestamp"))
            .attr("data-product-name", item_parent.data("cart-item-title"))
            .attr("data-product-sku", item_parent.data("variant-sku"))
            .attr("data-product-price", `$${parseFloat(item_parent.data("variant-protection-price"))/100}`)
            .attr(
              "data-product-quantity",
              item_parent.data("cart-item-quantity")
            );
        }
      );
      // Code to add protection product to cart
      $(document).on("click", ".protection-plan-wrapper .add-plan", function () {
        var active_warranty_button = $(this).closest(".protection-plan-wrapper").find("input:checked");
        if (!active_warranty_button.length) {
          alert("Select the warranty plan");
          return false;
        }
        var inputParent = active_warranty_button.closest(".grid__item");
        console.log("added to protection");
        var protection = { id: "", quantity: "", properties: {} }, formData = { items: [] };
        protection.quantity = inputParent.attr("data-product-quantity");
        protection.id = inputParent.attr("data-protection-id");
        protection.properties["_product name"] = inputParent.attr("data-product-name");
        protection.properties["_product price"] = inputParent.attr("data-product-price");
        protection.properties["_product SKU"] = inputParent.attr("data-product-sku");
        protection.properties["_timestamp"] = inputParent.attr("data-timestamp");
        formData.items.push(protection);
        $("body").addClass("show-cart-loader");
        $("body").removeClass("show-website-popup");
        $("#clarity-commitment-popup").removeClass("show-popup-content");
        $(".protection-plan-wrapper input").prop("checked", false);
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        }).then((response) => {
          ajaxCartDrawer.AjaxcartRender();
        }).catch((error) => {
          console.log("Error:", error);
        });
      });
      $(".skip-warranty-button").on("click", function () {
        $("body").removeClass("show-website-popup");
        $("#cart-warranty-popup").removeClass("show-popup-content");
      });
    },
    handleProtectionPlanChange: function (event) {
      // Code to change the protection plan tick on product page for both(i.e. product and popup)
      $(".protection-plan-wrapper label").on("click", function () {
        var closest_parent = $(this).closest(".grid__item");
        closest_parent.siblings().find("input").prop("checked", false);
        console.log(closest_parent.find("input").prop("checked"));
        if (closest_parent.find("input").prop("checked")) {
          closest_parent.find("input").prop("checked", false);
          $(".protection-plan-wrapper .lifetime-info").hide();
        } else {
          closest_parent.find("input").prop("checked", true);
          var inputValue = closest_parent.find("input").val();
          if (inputValue == "Lifetime") {
            $(".protection-plan-wrapper .lifetime-info").show();
          } else {
            $(".protection-plan-wrapper .lifetime-info").hide();
          }
        }
      });
    },
  };
  $("body").addClass("show-cart-loader");
  ajaxCartDrawer.AjaxcartRender();
  ajaxCartDrawer.AjaxcartQuantityHandler();
  ajaxCartDrawer.AjaxcartAddAppraisal();
  ajaxCartDrawer.handleBuyProtection();
  ajaxCartDrawer.handleProtectionPlanChange();
});
